import { createAction } from '@reduxjs/toolkit';

import * as actionTypes from './actionTypes';

export const getSellerConfiguration = createAction<string>(
  actionTypes.GET_SELLER_CONFIGURATION.BASE,
);

export const getSellersConfiguration = createAction<{ sellerIds: string[] }>(
  actionTypes.GET_SELLERS_CONFIGURATION.BASE,
);

export const setSellerConfigurationAcceptedLanguages = createAction<{
  sellerId: string;
  timestamp: string;
  acceptedLanguages: string[];
}>(actionTypes.SET_SELLER_CONFIGURATION_ACCEPTED_LANGUAGES.BASE);
